import React, { useState, useEffect } from "react";
import {
  FaEdit,
  FaLock,
  FaUserCircle,
  FaSignOutAlt,
  FaTimes,
  FaCheck,
  FaExclamationTriangle,
  FaShieldAlt,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCamera,
  FaKey,
  FaCalendarAlt,
  FaIdCard,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { userWallet } from "../../services/api";




import ChangePasswordPage from "./ChangePasswordPage";
import toast from "react-hot-toast";

// ========== EDIT PROFILE MODAL ==========
const EditProfileModal = ({ isOpen, onClose, user, onUpdate }) => {
  const [formData, setFormData] = useState({
    fullName: user.fullName || "",
    phone: user.phone || "",
    address: user.address || "",
    city: user.city || "",
  });

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false); 
  const [wallet, setWallet] = useState(null);
// ✅ ADD THIS

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable background scroll
    } else {
      document.body.style.overflow = "auto"; // Enable again
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup when modal closes / unmount
    };
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Read file and convert to base64, store into formData.image
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // Basic file type/size guard (optional)
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file.");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result;
      setFormData((prev) => ({ ...prev, image: base64 }));
    };
    reader.onerror = () => {
      toast.error("Failed to read image file.");
    };
    reader.readAsDataURL(file);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Name is required";
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = "Name must be at least 2 characters";
    } else if (!/^[A-Za-z ]+$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Name must contain only letters and spaces";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix the errors");
      return;
    }

    setLoading(true);

    try {
      // Pass image in formData (base64) to updateProfile
      const payload = {
        fullName: formData.fullName.trim(),
        phone: formData.phone?.trim() || "",
        address: formData.address?.trim() || "",
        city: formData.city?.trim() || "",
        image: formData.image || "",
      };

      const result = updateProfile(user.email, payload);

      // Support both sync and async updateProfile returns
      const res = result instanceof Promise ? await result : result;

      if (res && res.success) {
        toast.success("Profile updated successfully!");
        // onUpdate expects updated user object
        if (res.user) {
          onUpdate(res.user);
        } else {
          // Fallback: merge local payload into user
          onUpdate({ ...user, ...payload });
        }
        onClose();
      }  else {
        toast.error((res && res.message) || "Failed to update profile", {
          id: ERROR_TOAST_ID,
        });
      }
    } catch (err) {
      console.error("updateProfile error:", err);
      toast.error("Failed to update profile", {
        id: ERROR_TOAST_ID,
      });
    } finally {
      setLoading(false);
    }
  };
  

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg">
                <FaEdit className="text-xl" />
              </div>
              <div>
                <h2 className="text-xl font-bold">Edit Profile</h2>
                <p className="text-orange-100 text-sm">
                  Update your information
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              disabled={loading}
              className="p-2 hover:bg-white/20 rounded-lg transition-all"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          
          {/* EMAIL */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email (Cannot be changed)
            </label>
            <input
              type="email"
              value={user.email}
              disabled
              className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 cursor-not-allowed"
            />
          </div>

          {/* ADDRESS (purohit only) */}
          {user.accountType === "purohit" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#EB4E1E] focus:border-transparent"
                disabled={loading}
              />
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] text-white rounded-lg font-semibold hover:from-[#d84315] hover:to-[#ff5722] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Saving Changes..." : "Save Changes"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ========== MAIN PROFILE PAGE ==========
export default function UserProfilePage() {
  const navigate = useNavigate();

  // Load data from centralized auth system
  const { auth, logout, loading } = useAuth();
  const [userData, setUserData] = useState(null);
  const [wallet, setWallet] = useState(null);


  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  useEffect(() => {
    // ⛔ wait until AuthContext finishes restoring from localStorage
    if (loading) return;

    if (!auth.isAuthenticated) {
      toast.error("Please login to view profile");
      navigate("/login");
      return;
    }

    setUserData({
      ...auth.user,
      image:
        auth.user.image ||
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      memberSince: auth.user.createdAt
        ? new Date(auth.user.createdAt).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })
        : "",
    });
  }, [loading, auth.isAuthenticated, auth.user, navigate]);


  useEffect(() => {
  const loadWallet = async () => {
    try {
      const res = await userWallet();
      setWallet(res.data);
    } catch (err) {
      console.error("Wallet load failed", err);
    }
  };

  loadWallet();
}, []);


  const handleUpdateProfile = (updatedUser) => {
    // Merge updated user info into UI
    setUserData((prev) => ({
      ...prev,
      ...updatedUser,
      // ensure memberSince / image fallback
      memberSince: prev?.memberSince,
      image: updatedUser.image || prev?.image,
    }));
  };

  const handleLogout = () => {
    logout(); // AuthContext logout
    toast.success("Logged out successfully");
    navigate("/login");
  };

  if (!userData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-20 pb-12 px-4 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-20 pb-12 px-4">
      <ChangePasswordPage
        isOpen={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />
      <EditProfileModal
        isOpen={profileModalOpen}
        onClose={() => setProfileModalOpen(false)}
        user={userData}
        onUpdate={handleUpdateProfile}
      />

      <div className="max-w-4xl mx-auto">
        {/* Single Column - One by One Cards */}
        <div className="mt-6 space-y-6 mb-8">



          


          {/* 1. USER PROFILE CARD */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            {/* Orange Header */}
            <div className="bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] p-6">
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                <div className="relative w-24 h-24">
                  <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center border-4 border-white shadow-xl overflow-hidden">
                    {userData.image ? (
                      <img
                        src={userData.image}
                        alt="Profile"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <FaUser className="text-gray-500" size={36} />
                    )}
                  </div>

                  {/* Add / Edit photo quick action on the card (opens modal) */}
                  <button
                    onClick={() => setProfileModalOpen(true)}
                    className="absolute -bottom-1 -right-1 bg-white rounded-full p-1 shadow-md border border-gray-100"
                    title="Add / Change Photo"
                  >
                    <div className="w-7 h-7 rounded-full bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] text-white flex items-center justify-center">
                      <FaCamera className="w-3.5 h-3.5" />
                    </div>
                  </button>
                </div>

                <div className="text-center sm:text-left flex-1">
                  <h2 className="text-2xl font-bold text-white">
                    {userData.fullName}
                  </h2>
                  <p className="text-orange-100 text-sm mt-1 flex items-center justify-center sm:justify-start gap-2">
                    <FaEnvelope /> {userData.email}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-2 justify-center sm:justify-start">
                    <span className="inline-block bg-white/20 text-white text-xs px-3 py-1 rounded-full font-medium capitalize">
                      <FaIdCard className="inline mr-1" />{" "}
                      {userData.accountType} Account
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. PROFILE INFORMATION CARD */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] rounded-xl">
                  <FaIdCard className="text-white text-xl" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Profile Information
                  </h3>
                  <p className="text-gray-600 text-sm">
                    View and edit your personal details
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6">
             

              <button
                onClick={() => setProfileModalOpen(true)}
                className="w-full py-3 bg-gradient-to-r from-[#EB4E1E] to-[#ff7043] hover:from-[#d84315] hover:to-[#ff5722] text-white rounded-xl font-semibold transition-all shadow hover:shadow-lg flex items-center justify-center gap-3"
              >
                <FaEdit size={18} /> Edit Profile Details
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
  {/* Header */}
  <div className="p-6 border-b border-gray-200">
    <div className="flex items-center gap-3">
      <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl">
        <FaShieldAlt className="text-white text-xl" />
      </div>
      <div>
        <h3 className="text-xl font-bold text-gray-900">
          Wallet & Credits
        </h3>
        <p className="text-gray-600 text-sm">
          Manage your platform unlock credits
        </p>
      </div>
    </div>
  </div>

  {/* Body */}
  <div className="p-6">
    {wallet ? (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Total Credits */}
        <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 text-center">
          <p className="text-sm text-gray-600">Total Credits</p>
          <p className="text-2xl font-bold text-orange-600 mt-1">
            {wallet.totalCredits}
          </p>
        </div>

        {/* Used Credits */}
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
          <p className="text-sm text-gray-600">Used Credits</p>
          <p className="text-2xl font-bold text-red-600 mt-1">
            {wallet.usedCredits}
          </p>
        </div>

        {/* Remaining Credits */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-center">
          <p className="text-sm text-gray-600">Remaining Credits</p>
          <p className="text-2xl font-bold text-green-600 mt-1">
            {wallet.remainingCredits}
          </p>
        </div>
      </div>
    ) : (
      <div className="text-center text-gray-500">
        Loading wallet...
      </div>
    )}
  </div>
</div>

        </div>
      </div>
    </div>
  );
}
